import { FC } from "react";
import { Button, CircularProgress, Grid, IconButton, InputAdornment, Modal, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik } from "formik";
import { Product } from "../../../types/slices/productType";
import { useStockProductStore } from "../../../hooks/useStockProductStore";
import { ApiStatus } from "../../../types/api/status";

interface Props {
    open: boolean
    selectedProduct: any
    stockStore: any
    onClose: () => void
    onList: () => Promise<void>
    getProductsApi: () => Promise<void>
}

interface FormData {
    idproduct: number
    idwarehouse: number | undefined
    quantity: number | undefined
}

interface FormErrors {
    idproduct?: string
    idwarehouse?: string
    type_movement?: string
    quantity?: string
}


export const AdjustmentModal: FC<Props> = (props) => {
    const { open, selectedProduct, stockStore, onClose, onList, getProductsApi } = props

    const { status: statusStock, createAdjustment } = useStockProductStore()

    const data: FormData = {
        idproduct: selectedProduct?.id,
        idwarehouse: stockStore?.id,
        quantity: stockStore?.stock,
    }

    const validateForm = (values) => {
        let errors: FormErrors = {}

        if (!values.quantity) errors.quantity = "el campo es requerido"
        if (!values.idwarehouse) errors.idwarehouse = "el campo es requerido"

        return errors
    }

    const onSubmit = async (values: FormData) => {
        const resp = await createAdjustment(values)
        if (resp === true) {
            onList()
            getProductsApi()
            onClose()
        }
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Grid container spacing={2}
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2,
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    width: '400px',
                    boxShadow: 24,
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: '#000',
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <>
                                <Grid item xs={12}>
                                    <Typography
                                        id="modal-title"
                                        variant="h6"
                                        component="h2"
                                        sx={{ fontWeight: 'bold', textAlign: 'center' }}
                                    >
                                        Ajuste
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="store"
                                        fullWidth
                                        value={stockStore?.name}
                                        label="Bodega"
                                        variant="outlined"
                                        size="small"
                                        type="text"
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="quantity"
                                        fullWidth
                                        value={values.quantity}
                                        onChange={(e) => {
                                            const { value } = e.target

                                            const isValid =
                                                selectedProduct?.idunitmeasure === 1
                                                    ? /^\d+$/.test(value)
                                                    : /^\d*\.?\d{0,2}$/.test(value)

                                            if (isValid || value === "") {
                                                setFieldValue("quantity", value)
                                            }
                                        }}
                                        label="Cantidad"
                                        variant="outlined"
                                        size="small"
                                        type="text"
                                        error={Boolean(errors.quantity && touched.quantity)}
                                        helperText={errors.quantity && touched.quantity ? errors.quantity : ''}
                                        autoFocus
                                        inputProps={{
                                            min: 0,
                                            inputMode: "decimal",
                                            pattern: "[0-9]*"
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <span>{selectedProduct?.unitmeasure || ''}</span>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sx={{ textAlign: 'right', marginTop: 2 }}>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        sx={{
                                            backgroundColor: '#516E80',
                                            color: '#fff',
                                            fontWeight: 'bold',
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            textTransform: 'none',
                                            "&:hover": {
                                                backgroundColor: "#405563",
                                            },
                                        }}
                                        onClick={() => handleSubmit()}
                                    >
                                        {statusStock === ApiStatus.FETCHING && (
                                            <CircularProgress color="inherit" size={16} sx={{ color: '#fff', marginRight: "10px" }} />
                                        )}
                                        Guardar
                                    </Button>
                                </Grid>
                            </>
                        )
                    }}
                </Formik>
            </Grid>
        </Modal>
    )
}